// Fuente única de verdad para los módulos del sistema de permisos.
// Debe coincidir con `_MODULES` en backend/app/models/users.py — si agregas
// o quitas un módulo aquí, agrégalo/quítalo también ahí.
import React from "react";

export const MODULOS = [
  { key: "conciliacion", label: "Centro de Conciliación", icon: <i className="fa-solid fa-handshake" />, path: "/materias/laboral/centro-conciliacion" },
  { key: "tribunal", label: "Tribunal", icon: <i className="fa-solid fa-gavel" />, path: "/materias/laboral/tribunal" },
  { key: "junta", label: "Junta de Conciliación", icon: <i className="fa-solid fa-clipboard-check" />, path: "/materias/laboral/junta-conciliacion" },
  { key: "desvinculaciones", label: "Desvinculaciones", icon: <i className="fa-solid fa-user-minus" />, path: "/materias/laboral/desvinculaciones" },
  { key: "abogados", label: "Abogados", icon: <i className="fa-solid fa-people-group" />, path: "/abogados" },
  { key: "agenda", label: "Agenda", icon: <i className="fa-solid fa-calendar" />, path: "/agenda" },
  { key: "informes", label: "Informes", icon: <i className="fa-solid fa-chart-simple" />, path: "/informes" },
  { key: "autoridades", label: "Autoridades", icon: <i className="fa-solid fa-landmark" />, path: "/autoridades" },
  { key: "configuracion", label: "Configuración", icon: <i className="fa-solid fa-gears" />, path: "/configuracion" },
  { key: "corresponsales", label: "Corresponsales", icon: <i className="fa-solid fa-address-book" />, path: "/corresponsales" },
  { key: "empresas", label: "Empresas", icon: <i className="fa-solid fa-city" />, path: "/empresas" },
  { key: "usuarios", label: "Usuarios", icon: <i className="fa-solid fa-users" />, path: "/usuarios" },
  { key: "programador", label: "Programador", icon: <i className="fa-solid fa-code" />, path: "/programador" },
];

export const MODULO_KEYS = MODULOS.map((m) => m.key);

export const MODULOS_BY_KEY = Object.fromEntries(MODULOS.map((m) => [m.key, m]));

export const ACTIONS = [
  { key: "modulo", label: "Módulo" },
  { key: "consultar", label: "Consultar" },
  { key: "insertar", label: "Insertar" },
  { key: "editar", label: "Editar" },
  { key: "eliminar", label: "Eliminar" },
];

export const ACTION_KEYS = ACTIONS.map((a) => a.key);
